import React from 'react';
import ConfirmationDialog from 'components/ConfirmationDialog/ConfirmationDialog';

import styles from './dbgTemplateConfirmationModal.module.less';

type Props = {
  visible: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

const DBGTemplateConfirmationModal = (props: Props) => {
  const { visible, onConfirm, onCancel } = props;

  return (
    <ConfirmationDialog
      title="Save As Default Template"
      okText="Yes - Save as Default Template"
      cancelText="Cancel"
      onCancel={onCancel}
      onOk={onConfirm}
      visible={visible}
      width={464}
      flipFooterOrder={true}
    >
      <p className={styles.confirmationText}>
        Are you sure you want to set this disclosure as the default template?
        This will be used as the starting point for all future microsite
        disclosure sections. You can still customize each one later in the
        Disclosure Editor
      </p>
    </ConfirmationDialog>
  );
};

export default DBGTemplateConfirmationModal;
